__webpack_require__.p = "/CM-memory-seller/";